import { ECHART_COLOR } from '@gp/constants/const';

export const MANAGEMENT_TEAM_DESCRIPTION_TEMPLATE = '${studioName} Holdings has current team members,including Founder, CEO & Executive Director ${ceoName}.';

const MANAGEMENT_TEAM_COLUMNS = 3;

const MANAGEMENT_TEAM_MIN_SHOW_ROWS = 1;

export const MANAGEMENT_TEAM_MIN_SHOW_CELLS = MANAGEMENT_TEAM_MIN_SHOW_ROWS * MANAGEMENT_TEAM_COLUMNS;

export const MAX_DIFF_MONTHS = 24;

export const HEADCOUNTS_KEY_MAP: {
  [key: string]: {
    metricKeyName: 'functionMetrics' | 'projectMetrics',
    dataKeyName: 'functionList' | 'projectList',
  },
} = {
  '1': {
    metricKeyName: 'functionMetrics',
    dataKeyName: 'functionList',
  },
  '2': {
    metricKeyName: 'projectMetrics',
    dataKeyName: 'projectList',
  },
};

export const FIELD_MAP: {[keyName: string]: {[keyName: string]: string}} = {
  'headcounts': {
    'publishing and marketing': 'Publishing & Marketing staffs',
    'publishing and marketing staffs': 'Publishing & Marketing staffs',
    'publishing&marketing': 'Publishing & Marketing staffs',
    'publishing&marketing staffs': 'Publishing & Marketing staffs',
  },
  '5y_headcounts': {
    'publishing and marketing': 'Publishing & Marketing staffs',
    'publishing and marketing staffs': 'Publishing & Marketing staffs',
    'publishing&marketing': 'Publishing & Marketing staffs',
    'publishing&marketing staffs': 'Publishing & Marketing staffs',
  },
  'headcount_cost': {
    'development cost': 'R&D cost',
    'development': 'R&D cost',
    'marketing cost': 'Publishing & Marketing cost',
    'marketing': 'Publishing & Marketing cost',
    'overhead': 'Others',
    'overheads': 'Others',
  },
};

export const FIXED_FIELD_SERIES_ITEM_COLOR_ARR = [
  'r&d',
  'r & d',
  'publishing & marketing',
  'publishing&marketing',
  'others',
];

export const FIXED_FIELD_SERIES_ITEM_COLOR_MAP: {[keyName: string]: string} = {
  [FIXED_FIELD_SERIES_ITEM_COLOR_ARR[0]]: ECHART_COLOR[0],
  [FIXED_FIELD_SERIES_ITEM_COLOR_ARR[1]]: ECHART_COLOR[0],
  [FIXED_FIELD_SERIES_ITEM_COLOR_ARR[2]]: ECHART_COLOR[1],
  [FIXED_FIELD_SERIES_ITEM_COLOR_ARR[3]]: ECHART_COLOR[1],
  [FIXED_FIELD_SERIES_ITEM_COLOR_ARR[4]]: ECHART_COLOR[2],
};
